import React, { useRef, useEffect } from 'react';

const CustomTimePicker = ({ value, onChange, onClose }) => {
  const listRef = useRef(null);
  
  // Generate all time slots in 15-minute intervals (12-hour format with AM/PM)
  const generateTimeSlots = () => {
    const slots = [];
    for (let h = 0; h < 24; h++) {
      for (let m = 0; m < 60; m += 15) {
        const hour24 = h;
        const hour12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
        const ampm = h < 12 ? 'AM' : 'PM';
        const timeValue = `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`;
        const timeDisplay = `${hour12}:${m.toString().padStart(2, '0')} ${ampm}`;
        slots.push({ value: timeValue, display: timeDisplay });
      }
    }
    return slots;
  };

  const timeSlots = generateTimeSlots();

  // Scroll to selected time on mount
  useEffect(() => {
    if (listRef.current && value) {
      const selectedIndex = timeSlots.findIndex(slot => slot.value === value);
      if (selectedIndex !== -1) {
        const itemHeight = 44; // Approximate height of each item
        listRef.current.scrollTop = selectedIndex * itemHeight - 100;
      }
    }
  }, [value, timeSlots]);

  const handleSelect = (timeValue) => {
    onChange(timeValue);
    onClose();
  };

  return (
    <div className="bg-white rounded-xl shadow-lg border border-gray-200 w-full overflow-hidden">
      {/* Scrollable list */}
      <div 
        ref={listRef}
        className="max-h-[280px] overflow-y-auto"
      >
        {timeSlots.map((slot) => (
          <div
            key={slot.value}
            onClick={() => handleSelect(slot.value)}
            className={`
              px-4 py-3 cursor-pointer transition-colors
              ${value === slot.value 
                ? 'bg-[#36827f]/10 text-[#36827f] font-medium' 
                : 'text-gray-700 hover:bg-gray-50'}
            `}
          >
            {slot.display}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomTimePicker;
